module.exports = __webpack_public_path__ + "img/Box.8c702ac7.svg";